import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseOverlayButton from "../close-overlay-button";
function ToolOverlay({ text = null, children, label, onClose }) {
    return (_jsxs("div", { className: "ms3-tool-overlay", children: [_jsx(CloseOverlayButton, { onClose: onClose }), _jsx("h3", { className: "ms3-tool-overlay__header", children: label }), text && _jsx("p", { className: "ms3-tool-overlay__text", children: text }), children] }));
}
export default ToolOverlay;
